<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="手机号" prop="phone">
            <el-input size="small" style="width: 200px;" v-model="formInline.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item label="请选择身份" prop="status">
            <el-select v-model="formInline.type" placeholder="请选择状态">
              <el-option label="普通用户" :value = 0></el-option>
              <el-option label="仓管人员" :value = 1 ></el-option>
              <el-option label="财务人员" :value = 2 ></el-option>
              <el-option label="财务复核人员" :value = 4 ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="请选择状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择状态">
              <el-option label="正常" :value = 0></el-option>
              <el-option label="禁用" :value = 1 ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="nickName" label="姓名" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号" align="center"></el-table-column>

          <el-table-column prop="type" label="身份" align="center">
            <template slot-scope="scope">
              <el-tag type="danger" effect="dark" v-if="scope.row.type==0">普通用户</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==1">仓管人员</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==2">财务人员</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==3">仓管、财务人员</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==4">财务复核人员</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==5">财务复核、仓管人员</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==6">财务复核、财务人员</el-tag>
              <el-tag type="danger" effect="dark" v-if="scope.row.type==7">财务复核、仓管、财务人员</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="status" label="状态" width="170px" >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="正常"
                inactive-text="禁用"
                :active-value="0"
                :inactive-value="1"
                @change="turn(scope.row)">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="createTime" label="登录时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>



        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">
            <el-form-item label="姓名" prop="name">
              <el-input size="small" v-model="editForm.name"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="手机号" prop="phone">
              <el-input size="small" v-model="editForm.phone"  :autosize="{ minRows: 2}" style="width: 70%"  auto-complete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input v-model="editForm.password" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="用户身份" prop="type">
              <el-select v-model="editForm.type" placeholder="请选择"  style="height: 33px;width: 250px;">
                <el-option
                  v-for="item in typeSelect"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="仓管展会权限" prop="cgList" v-if="editForm.type == 1 || editForm.type == 3|| editForm.type == 5|| editForm.type == 7">
              <el-checkbox-group v-model="editForm.cgList">
                <el-checkbox  v-for="(operate, index) in exhList"
                              :label="operate.id">
                  {{operate.exhibitionName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="财务展会权限" prop="cgList" v-if="editForm.type == 2 || editForm.type == 3|| editForm.type == 6|| editForm.type == 7">
              <el-checkbox-group v-model="editForm.cwList">
                <el-checkbox  v-for="(operate, index) in exhList"
                              :label="operate.id">
                  {{operate.exhibitionName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="财务复核展会权限" prop="cgList" v-if="editForm.type == 4 || editForm.type == 5|| editForm.type == 6|| editForm.type == 7">
              <el-checkbox-group v-model="editForm.fhList">
                <el-checkbox  v-for="(operate, index) in exhList"
                              :label="operate.id">
                  {{operate.exhibitionName}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>



import {qryUserList,upUser,upStatus} from '../../api/userApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import {qryExhibitionList} from "../../api/courseApi";


export default {
  name: "activityRankingList",
  data() {
    return {
      title:'修改',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        phone:'',
        status:'',
        type:'',
        page:1,
        pageSize:10
      },
      listData:[],
      exhList:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm:{
        id:'',
        name:'',
        phone:'',
        password:'',
        type:'',
        cgList:[],
        cwList:[],
        fhList:[],
      },
      // rules表单验证
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ] ,
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择身份', trigger: 'blur' }
        ],
      },
      typeSelect:[{"name":"普通用户","value":0},
        {"name":"仓管人员","value":1},
        {"name":"财务人员","value":2},
        {"name":"仓管、财务人员","value":3},
        {"name":"财务复核人员","value":4},
        {"name":"财务复核、仓管人员","value":5},
        {"name":"财务复核、财务人员","value":6},
        {"name":"财务复核、仓管、财务人员","value":7}],


    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryUserList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })

      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

    },

    resetFrom(){
      this.formInline.phone = '';
      this.formInline.status = '';
      this.formInline.type = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    turn(row) {
      var data={
        id:row.id,
        status:row.status
      }
      upStatus(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList(this.formInline)
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
      })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.title = '修改'
      this.editForm.id = row.id
      this.editForm.name = row.name
      this.editForm.phone = row.phone
      this.editForm.password = row.password
      this.editForm.type = row.type
      if (row.cgList){
        this.editForm.cgList = row.cgList.split(",")
      }else {
        this.editForm.cgList=[]
      }

      if (row.cwList){
        this.editForm.cwList = row.cwList.split(",")
      }else {
        this.editForm.cwList=[]
      }

      if (row.fhList){
        this.editForm.fhList = row.fhList.split(",")
      }else {
        this.editForm.fhList=[]
      }

      console.log("this.editForm",this.editForm)
    },
    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.baseForm = [];
      this.editFormVisible = false;
    },

    // 编辑、添加提交方法
    submitForm(editData) {
      console.log("this.editForm",this.editForm)
      if (this.editForm.cgList){
        this.editForm.cgList= this.editForm.cgList.join(",")
      }
      if (this.editForm.cwList){
        this.editForm.cwList= this.editForm.cwList.join(",")
      }
      if (this.editForm.fhList){
        this.editForm.fhList= this.editForm.fhList.join(",")
      }

      if (this.editForm.type == 1){
        if (this.editForm.cgList == null || this.editForm.cgList == ''){
          this.$message.error('请选择展会权限！')
          this.editForm.cgList=[]
          return
        }
      }
      if (this.editForm.type == 2){
        if (this.editForm.cwList == null || this.editForm.cwList == ''){
          this.$message.error('请选择展会权限！')
          this.editForm.cwList=[]
          return
        }
      }
      if (this.editForm.type == 3){
        if (this.editForm.cwList == null || this.editForm.cwList == ''||this.editForm.cgList == null || this.editForm.cgList == ''){
          this.$message.error('请选择展会权限！')
          this.editForm.cwList=[]
          this.editForm.cgList=[]
          return
        }
      }

      if (this.editForm.type == 4){
        if (this.editForm.fhList == null || this.editForm.fhList == ''){
          this.$message.error('请选择展会权限！')
          this.editForm.fhList=[]
          return
        }
      }

      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upUser(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.editFormVisible = false
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },




  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/userList.vue